import React, { useState } from "react";
import "./ExportModal.css";
import * as FeatherIcon from "react-feather";

const ExportModal = ({
  categories = [],
  exportType = "",
  onExport,
  onBack,
}) => {
  const [expanded, setExpanded] = useState({});
  const [selected, setSelected] = useState({});

  const toggleCategory = (cat) => {
    setExpanded((prev) => ({ ...prev, [cat]: !prev[cat] }));
  };

  const handleCategoryCheck = (cat, isChecked) => {
    const subs = categories.find((c) => c.name === cat)?.subDimensions || [];
    setSelected((prev) => ({
      ...prev,
      [cat]: isChecked ? new Set(subs) : new Set(),
    }));
  };

  const handleSubCheck = (cat, sub, isChecked) => {
    setSelected((prev) => {
      const updated = new Set(prev[cat] || []);
      isChecked ? updated.add(sub) : updated.delete(sub);
      return { ...prev, [cat]: updated };
    });
  };

  const isCategoryChecked = (cat) => {
    const subs = categories.find((c) => c.name === cat)?.subDimensions || [];
    return selected[cat]?.size === subs.length;
  };

  const isSubChecked = (cat, sub) => selected[cat]?.has(sub);

  const handleExport = () => {
    const result = {};
    for (let cat in selected) {
      if (selected[cat].size > 0) {
        result[cat] = Array.from(selected[cat]);
      }
    }
    onExport(result);
  };

  return (
    <div className="export-panel">
      <div className="export-panel-header">
        <button className="back-button" onClick={onBack}>
          <FeatherIcon.ChevronLeft className="top_icons" />
        </button>
        <span className="export-type-label">
          Export to .{exportType?.toUpperCase()}
        </span>
      </div>

      <h4 className="section-heading">Select sections</h4>

      <div className="category-list">
        {categories.map(({ name, subDimensions }) => (
          <div key={name} className="category-block">
            <div className="category-header">
              <button
                className="toggle-btn"
                onClick={() => toggleCategory(name)}
              >
                {/* {expanded[name] ? "▾" : "▸"} */}
                {expanded[name] ? (
                  <FeatherIcon.ChevronUp className="accord_arrow" />
                ) : (
                  <FeatherIcon.ChevronDown className="accord_arrow" />
                )}
              </button>
              <input
                type="checkbox"
                checked={isCategoryChecked(name)}
                onChange={(e) => handleCategoryCheck(name, e.target.checked)}
              />
              <span className="category_dropdown_head">{name}</span>
            </div>
            {expanded[name] && (
              <div className="subcategory-list">
                {subDimensions.map((sub) => (
                  <div
                    key={sub}
                    className={`subcategory-item ${
                      isSubChecked(name, sub) ? "checked" : ""
                    }`}
                  >
                    <input
                      type="checkbox"
                      checked={isSubChecked(name, sub)}
                      onChange={(e) =>
                        handleSubCheck(name, sub, e.target.checked)
                      }
                    />
                    <span className="category_dropdown_subhead">{sub}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="export_block_footer">
        <button className="export-btn" onClick={handleExport}>
          Export Selected
        </button>
      </div>
    </div>
  );
};

export default ExportModal;
